import { BaseEntity,IBaseEntity } from '../BaseEntity';
import { GENDER, UserType } from '../../Shared/enum';
import { UserAddress } from './UserAddress';
import { IAttribute } from '../Attribute';
import { UserRole } from '../Common/UserRole';

export class User extends BaseEntity {
  ID: number;
  Name: string;
  FirstName: string;
  LastName: string;
  Salutation: string;
  DateOfBirth: Date;
  Gender: GENDER;
  UserName: string;
  UserRef: string;
  UserGuid: string;
  Status: string;
  Address: UserAddress[];
  Email: string;
  AlternateEmail: string;
  Contact1: string;
  Contact2: string;
  Occupation: string;
  IsActive: boolean;
  MiscellaneousInfo: IAttribute[];
  UserType: UserType;
  UserRoles: UserRole[];
  IdentityId: string;
}


export interface IUser extends IBaseEntity {
  ID: number;
  Name: string;
  LastName: string;
  Salutation: string;
  DateOfBirth: Date;
  Gender: GENDER;
  UserName: string;
  UserRef: string;
  UserGuid: string;
  Status: string;
  Address: UserAddress[];
  Email: string;
  AlternateEmail: string;
  Contact1: string;
  Contact2: string;
  Occupation: string;
  IsActive: boolean;
  MiscellaneousInfo: IAttribute[];
  UserType: UserType;
  UserRoles: UserRole[];
  IdentityId: string;
}
